import {action, computed, runInAction} from "mobx";

import {
    TemplateColumnListItemInput,
    TemplateUpsertInput,
} from "../../../api/values/database-upsert-input";
import {Permission} from "../../../stores/authentication-store";
import {DatabaseFormBaseStore} from "../../../stores/database-template/database-form-base";
import {PageStoreConstructorOptions} from "../../../utils/page-store";
import {ColumnDef} from "../../atoms/tables/table";

export class DatabaseTemplateCreatePageStore extends DatabaseFormBaseStore {
    /**
     * テーブルヘッダーのデフォルト値
     * @type {ColumnDef[]}
     */
    public static readonly DEFAULT_COLUMN_DEFS: ColumnDef[] = [
        {label: "項目ID", width: 187},
        {label: "項目名", width: 187},
        {label: "データの種類", width: 120},
        {label: "説明", width: 598, required: false},
        {label: "", width: 94, required: false},
    ];

    /**
     * データベーステンプレートの列定義のデフォルト値を取得します。
     * @returns {ColumnDef[]} デフォルトの列定義
     */
    public get DEFAULT_COLUMN_DEFS(): ColumnDef[] {
        return DatabaseTemplateCreatePageStore.DEFAULT_COLUMN_DEFS;
    }
    constructor(options: PageStoreConstructorOptions) {
        super(options);
    }
    public async initialize({query}: {query: {mediaId: string}}): Promise<void> {
        this.stores.authenticationStore.checkAnyPermissionExists(Permission.EDIT_GENERAL_RESOURCES);
        this.setMediaId(query.mediaId || "");
    }

    /**
     *  新しいテンプレートの作成
     */
    @action.bound
    public async createTemplate() {
        const dto = new TemplateUpsertInput({
            title: this.templateName,
            note: this.templateNote,
            templateColumnList: this.templateColumnList.map(
                (r) =>
                    new TemplateColumnListItemInput({
                        slug: r.slug,
                        label: r.label,
                        type: r.type,
                        note: r.note,
                        deleted: false,
                    }),
            ),
        });

        try {
            const result = await this.adminApi.postTemplate({mediaId: this.mediaId}, dto);
            runInAction(() => {
                this.pageRouter.pushRoute(
                    `/admin/${this.mediaId}/database-templates/detail/${result.id}`,
                );
            });
        } catch (error) {
            console.error("Error creating template:", error);
        }
    }
    /**
     * テンプレートの保存が可能かどうかを判定します。
     * @returns {boolean} 保存可能ならtrue、そうでなければfalse
     */
    @computed
    public get canCreate(): boolean {
        return this.canSave();
    }
}
